/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ added: NonNullable<unknown>, total: NonNullable<unknown> }} Jobs_Scraped_CountInputs */

const en_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.added} new jobs (${i?.total} found total)`)
};

const de_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} neue Stellen hinzugefügt (${i?.total} insgesamt gefunden)`)
};

const fr_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} nouveaux emplois ajoutés (${i?.total} trouvés au total)`)
};

const es_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} nuevos empleos añadidos (${i?.total} encontrados en total)`)
};

const it_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiunti ${i?.added} nuovi lavori (${i?.total} trovati in totale)`)
};

const nl_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} nieuwe banen toegevoegd (${i?.total} totaal gevonden)`)
};

const pl_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dodano ${i?.added} nowych ofert (${i?.total} znalezionych łącznie)`)
};

const fi_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lisätty ${i?.added} uutta työpaikkaa (${i?.total} löydetty yhteensä)`)
};

const da_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilføjede ${i?.added} nye job (${i?.total} fundet i alt)`)
};

const sv_jobs_scraped_count = /** @type {(inputs: Jobs_Scraped_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lade till ${i?.added} nya jobb (${i?.total} hittade totalt)`)
};

/**
* | output |
* | --- |
* | "Added {added} new jobs ({total} found total)" |
*
* @param {Jobs_Scraped_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_scraped_count = /** @type {((inputs: Jobs_Scraped_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Scraped_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_scraped_count(inputs)
	if (locale === "fr") return fr_jobs_scraped_count(inputs)
	if (locale === "es") return es_jobs_scraped_count(inputs)
	if (locale === "it") return it_jobs_scraped_count(inputs)
	if (locale === "nl") return nl_jobs_scraped_count(inputs)
	if (locale === "pl") return pl_jobs_scraped_count(inputs)
	if (locale === "fi") return fi_jobs_scraped_count(inputs)
	if (locale === "da") return da_jobs_scraped_count(inputs)
	if (locale === "sv") return sv_jobs_scraped_count(inputs)
	return en_jobs_scraped_count(inputs)
});